module.exports = __webpack_public_path__ + "img/关于我们页面公司LOGO.8a97d96e.png";